import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import DiskCleanupScanInfo from 'components/DiskCleanupScanInfo';

import { DiskCleanupResult_cleanInfo$key } from '__generated__/DiskCleanupResult_cleanInfo.graphql';

type Props = {
  title?: string;
  loading: boolean;
  cleanInfo: DiskCleanupResult_cleanInfo$key | null;
};

const DiskCleanupResult: FC<Props> = props => {
  const cleanInfo = useFragment(
    graphql`
      fragment DiskCleanupResult_cleanInfo on CleanInfo {
        ...DiskCleanupScanInfo_scanInfo
      }
    `,
    props.cleanInfo
  );

  return (
    <Box sx={{ width: '130px' }}>
      {props.loading ? (
        <CircularProgress size={30} />
      ) : (
        cleanInfo && (
          <DiskCleanupScanInfo title={props.title} cleanInfo={cleanInfo} />
        )
      )}
    </Box>
  );
};

export default DiskCleanupResult;
